<template>
  <v-card class="mx-4">
    <!-- <v-layout class="buttons" justify-end row align-center>
        <v-btn
          class="TierButton mb-1 mr-0 ml-1"
          @click="openCreateUserForm()"
        >
          + New User
        </v-btn>
    </v-layout>-->
    <v-data-table
      :headers="headers"
      :items="releaseNotes"
      :item-key="releaseNotes.index"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      :loading="loading"
      :total-items="totalRecords"
      @update:pagination="paginationUpdated"
      hide-details
      class="no-pagination-btn"
    >
      <template slot="items" slot-scope="props">
        <tr
          :key="props.index"
          :active="props.selected"
          :style="{
                        backgroundColor: (props.item.ReleaseID == selectedRow ? '#C6EFCE' : (isEven(props.index) ? '#f9f9f9': 'transparent') ), 
                        color: (props.item.ReleaseID == selectedRow ? '#00612e' : 'black' ),
                      }"
        >
          <td class="text-xs-left px-0">{{ props.item["Version"] }}</td>
          <td class="text-xs-left px-0">{{ props.item["ReleaseDate"] | formatDate}}</td>
          <td class="text-xs-left px-0 fill-width" colspan="3">
            <v-layout
              child-flex
              v-for="(details, index) in props.item.Details"
              row
              wrap
              :key="index"
            >
              <tr
                :key="index"
                class="fill-width"
                :class="{releaseNotesDetail: index+1 < props.item.Details.length? true:false}"
              >
                <v-layout class="fill-width">
                  <v-flex style="width:17%; min-width:200px">
                    <td class="text-xs-left px-0">
                      <v-layout column>
                        <v-flex>
                          <text-highlight :queries="searchHighlight">{{details.MODULE}}</text-highlight>
                        </v-flex>
                        <!-- <v-divider v-if="index+1 < props.item.Details.length"></v-divider> -->
                      </v-layout>
                    </td>
                  </v-flex>
                  <v-flex style="width:67%; min-width:100px">
                    <td class="text-xs-left px-0">
                      <v-layout column>
                        <v-flex>
                          <text-highlight :queries="searchHighlight">{{details.NOTES}}</text-highlight>
                        </v-flex>
                        <!-- <v-divider v-if="index+1 < props.item.Details.length"></v-divider> -->
                      </v-layout>
                    </td>
                  </v-flex>
                  <v-flex style="width:16%; min-width:200px">
                    <td class="text-xs-left px-0">
                      <v-layout column>
                        <v-flex>
                          <text-highlight
                            :queries="searchHighlight"
                          >{{details.ENTRYDATE | formatDateTime}}</text-highlight>
                        </v-flex>
                        <!-- <v-divider v-if="index+1 < props.item.Details.length"></v-divider> -->
                      </v-layout>
                    </td>
                  </v-flex>
                </v-layout>
              </tr>
            </v-layout>
          </td>

          <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
            <a
              class="ml-0 align-center"
              style="text-decoration: none"
              @click="openAddReleaseNote(props.item)"
            >ADD</a>
          </td>
        </tr>
      </template>
      <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
    </v-data-table>
    <editReleaseNotes
      ref="editReleaseNotes"
      @parentRefresh="paginationUpdated"
      @parentInitSelectedRow="initSelectedRow"
      id="editReleaseNotes"
      @parentScroll="$vuetify.goTo('#editReleaseNotes')"
    ></editReleaseNotes>
  </v-card>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import Bus from "../../bus";
import zigZag from "../../components/ZigZag.vue";
import * as helper from "../../helpers/global.js";
import createUser from "./CreateUser.vue";
import moment from "moment";
import editReleaseNotes from "./EditReleaseNotesManagement.vue";
import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "ReleaseNotesManagement",

  components: {
    VPage,
    zigZag,
    createUser,
    editReleaseNotes,
    DataTablePagination
  },

  data: () => ({
    releaseNotes: [],
    loading: false,
    totalRecords: 0,
    filters: {},
    search: "",
    selectedRow: null,

    // Selected by default
    pagination: {
      rowsPerPage: 30,
      descending: true,
      totalRecords: 0,
      sortBy: "Version",
      page: 1
    },

    rowsPerPageItems: [5, 10, 30],

    headers: [
      {
        text: "Version",
        value: "Version",
        width: "7%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Release Date",
        value: "ReleaseDate",
        // sortable: false,
        width: "10%",
        fixed: true,
        align: "left",
        class:
          "font-weight-bold subheading text-align-right justify-end pr-0 pl-0"
      },
      {
        text: "Module",
        value: "Name",
        // sortable: false,
        width: "12%",
        fixed: true,
        align: "left",
        class:
          "pl-0 pr-0 font-weight-bold subheading sort-asc releaseNotesDetailModuleColumn"
      },

      {
        text: "Notes",
        value: "Notes",
        // sortable: false,
        width: "60%",
        fixed: true,
        align: "left",
        class:
          "pl-0 pr-0 font-weight-bold subheading sort-asc releaseNotesDetailNotesColumn"
      },
      {
        text: "Entry Date",
        value: "EntryDate",
        // sortable: false,
        width: "10%",
        fixed: true,
        align: "left",
        class:
          "pl-0 pr-0 font-weight-bold subheading sort-asc releaseNotesDetailEntryColumn"
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "10%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ]
  }),
  created() {
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },
  destroyed() {
    this.$root.$off("initialize", this.initialize);
  },
  mounted() {},
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    },
    formatDate: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format("YYYY/MM/DD");
      }
    }
  },
  methods: {
    async initialize() {
      this.filters = {};
      this.selectedRow = null;
      this.paginationUpdated();
    },
    async paginationUpdated() {
      this.loading = true;
      await axios
        .post(
          "/api/ReleaseNotes/GetPagedReleaseNotesList/",
          {
            postData: {
              pagination: this.pagination,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.releaseNotes = response.data.releaseNotes;
          // this.totalRecords = response.data.pagination.totalRecords;
        });
      this.loading = false;
    },
    isEven(n) {
      if (!isNaN(n)) {
        return n % 2 === 0;
      }
    },
    // categoryClass(item) {
    //   if (item) {
    //     var categoryClass;
    //     categoryClass = item
    //       .split(" ")
    //       .join("")
    //       .replace("/", "");
    //     return categoryClass;
    //   }
    // },
    async openEditReleaseNote(item) {
      let index = this.releaseNotes.indexOf(item);
      if (index > -1) {
        this.selectedRow = this.releaseNotes[index].ReleaseID;
      }
      // await this.$refs.createUser.close();
      this.$refs.editReleaseNotes.openEdit(item);
    },
    async openAddReleaseNote(item) {
      let index = this.releaseNotes.indexOf(item);
      if (index > -1) {
        this.selectedRow = this.releaseNotes[index].ReleaseID;
      }
      // await this.$refs.createUser.close();
      this.$refs.editReleaseNotes.openAdd(item);
    },
    initSelectedRow() {
      this.selectedRow = null;
    }
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
table.v-table tbody tr:hover {
  background-color: #eeeeee !important;
}

.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
.releaseNotesDetail {
  border-bottom: 1px solid #e0e0e0 !important;
}
/deep/.releaseNotesDetailModuleColumn {
  min-width: 200px !important;
}
/deep/.releaseNotesDetailNotesColumn {
  min-width: 200px !important;
}
/deep/.releaseNotesDetailEntryColumn {
  min-width: 200px !important;
}
</style>
